import { render, staticRenderFns } from "./license-details.vue?vue&type=template&id=53f1bada&"
import script from "./license-details.vue?vue&type=script&lang=js&"
export * from "./license-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports